import { render, staticRenderFns } from "./v-form-wizard-modal.vue?vue&type=template&id=c66d38de&"
import script from "./v-form-wizard-modal.vue?vue&type=script&lang=js&"
export * from "./v-form-wizard-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports